import { Button, Divider, Input } from "antd";
import user from "./../../assets/images/user.svg";
import arrowLeft from "./../../assets/images/arrow-left.svg";
import ProgressIndicator from "../../commonComponents/ProgressIndicator";
import { useLocation, useNavigate } from "react-router-dom";
import { useState } from "react";

const PatientName = () => {
  const navigate = useNavigate();
  const { state } = useLocation();
  const [patientName, setPatientName] = useState<string>(
    state?.patientName || ""
  );

  const patientNameHandler = (e: any) => {
    setPatientName(e.target.value);
  };
  const backBtnHandler = () => {
    navigate("/patient-phone-number", {
      state: { ...state },
    });
  };

  const continueBtnHandler = () => {
    navigate("/patient-summary", {
      state: { ...state, patientName: patientName?.trim() },
    });
  };

  return (
    <div className="p-6">
      <div className="flex items-start font-semibold gap-x-2 pb-5">
        <img
          height={22}
          width={22}
          src={arrowLeft}
          alt="arrow-left"
          onClick={backBtnHandler}
        />
        <span>Refer care plan</span>
      </div>
      <ProgressIndicator currentStep={4} totalSteps={4} />
      <div className="flex flex-col items-start">
        <div className="text-2xl font-medium pb-6 pt-6">Enter Patient Name</div>
        <label className="text-sm pb-1">Patient Name</label>
        <Input
          placeholder="Enter patient name"
          prefix={<img src={user} alt="user" className="p-2" />}
          onChange={patientNameHandler}
          value={patientName}
          name="doctorName"
          maxLength={30}
          autoFocus={true}
        />
      </div>
      <div className="w-full fixed bottom-0 left-0">
        <div className="mx-auto max-w-[1280px] w-full mx-auto max-w-[1280px] w-full">
          <Divider />
          <div className="p-6 pt-0">
            <Button
              type="primary"
              className="w-full h-14 rounded-2xl bg-[#4B4AD5] p-5 text-lg font-medium"
              onClick={continueBtnHandler}
              disabled={!patientName?.trim()?.length}
            >
              Continue
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PatientName;
